import React, { useState } from 'react';
import styled from 'styled-components';
import { DeviceType, WorkType } from '../../shared/enum/EnumRepository';
import { WorkFilterData } from '../../shared/dto/EntityRepository';
import { useDeviceStore } from '../../shared/store/deviceStore';
import { UniversalCheckbox } from '../../shared/component/UniversalCheckbox';

interface FilterStationWorkTypeProps {
  currentFilter: WorkFilterData;
  setCurrentFilter: (filter: WorkFilterData) => void;
}

const FilterStationWorkType: React.FC<FilterStationWorkTypeProps> = ({ currentFilter, setCurrentFilter }) => {
  const { deviceType } = useDeviceStore();
  const [workTypeAll, setWorkTypeAll] = useState(Object.values(currentFilter.workType).every(value => value));

  const handleWorkTypeChange = (workType: WorkType) => {
    setCurrentFilter({
      ...currentFilter,
      workType: { ...currentFilter?.workType, [workType]: !currentFilter?.workType?.[workType] },
    });
  }

  const handleWorkTypeChangeAll = () => {
    setCurrentFilter({
      ...currentFilter,
      workType: {
        [WorkType.PAINTING]: !workTypeAll,
        [WorkType.DRAWING]: !workTypeAll,
        [WorkType.PRINTS]: !workTypeAll,
        [WorkType.PHOTO]: !workTypeAll,
        [WorkType.DIGITAL]: !workTypeAll,
        [WorkType.INSTALLATION]: !workTypeAll,
        [WorkType.SCULPTURE]: !workTypeAll,
        [WorkType.CERAMIC]: !workTypeAll,
        [WorkType.TEXTILE]: !workTypeAll,
        [WorkType.CONCEPTUAL]: !workTypeAll,
        [WorkType.VIDEO]: !workTypeAll,
        [WorkType.PERFORMANCE]: !workTypeAll,
        [WorkType.BOOK]: !workTypeAll,
        [WorkType.NONE]: !workTypeAll,
      },
    });
    setWorkTypeAll(!workTypeAll);
  }

  return (
    <WorkTypeFilterComp>
      <WorkImportSubTitle $isMobile={deviceType === DeviceType.MOBILE}>Work Type</WorkImportSubTitle>
      <WorkTypeFilterList $isMobile={deviceType === DeviceType.MOBILE}>
        {Object.values(WorkType).map((workType) => (
          <CheckboxComp key={workType}>
            <UniversalCheckbox
              checked={currentFilter.workType?.[workType] ?? false}
              onChange={() => handleWorkTypeChange(workType)}
            />
            {workType}
          </CheckboxComp>
        ))}
        <CheckboxComp>
          <UniversalCheckbox
            checked={workTypeAll}
            onChange={() => handleWorkTypeChangeAll()}
          />
          Select ALL
        </CheckboxComp>

      </WorkTypeFilterList>
    </WorkTypeFilterComp>
  );
};


export default FilterStationWorkType;


export const WorkImportSubTitle = styled.div<{ $isMobile: boolean }>`
  margin-bottom: ${({ $isMobile }) => $isMobile ? '2vh' : '1.2vh'};
  ${({ theme, $isMobile }) => $isMobile ? theme.typography.Body_02_1 : theme.typography.Body_03_1};
`

const WorkTypeFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`
const WorkTypeFilterList = styled.div<{ $isMobile: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: ${({ $isMobile }) => $isMobile ? '2vw' : '20px'};
  row-gap: ${({ $isMobile }) => $isMobile ? '1vh' : '4px'};
`

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;